import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {FormulaPayableScheme, FormulaPayableSchemeInput} from './formula-payable-scheme.model';

export const loadFormulaPayableSchemes = createAction(
  '[FormulaPayableScheme/API] Load FormulaPayableSchemes',
  props<{ formulaPayableSchemes: FormulaPayableScheme[] }>()
);

export const addFormulaPayableScheme = createAction(
  '[FormulaPayableScheme/API] Add FormulaPayableScheme',
  props<{ formulaPayableScheme: FormulaPayableScheme }>()
);

export const upsertFormulaPayableScheme = createAction(
  '[FormulaPayableScheme/API] Upsert FormulaPayableScheme',
  props<{ formulaPayableScheme: FormulaPayableScheme }>()
);

export const addFormulaPayableSchemes = createAction(
  '[FormulaPayableScheme/API] Add FormulaPayableSchemes',
  props<{ formulaPayableSchemes: FormulaPayableScheme[] }>()
);

export const upsertFormulaPayableSchemes = createAction(
  '[FormulaPayableScheme/API] Upsert FormulaPayableSchemes',
  props<{ formulaPayableSchemes: FormulaPayableScheme[] }>()
);

export const updateFormulaPayableScheme = createAction(
  '[FormulaPayableScheme/API] Update FormulaPayableScheme',
  props<{ formulaPayableScheme: Update<FormulaPayableScheme> }>()
);

export const updateFormulaPayableSchemes = createAction(
  '[FormulaPayableScheme/API] Update FormulaPayableSchemes',
  props<{ formulaPayableSchemes: Update<FormulaPayableScheme>[] }>()
);

export const deleteFormulaPayableScheme = createAction(
  '[FormulaPayableScheme/API] Delete FormulaPayableScheme',
  props<{ id: string }>()
);

export const deleteFormulaPayableSchemes = createAction(
  '[FormulaPayableScheme/API] Delete FormulaPayableSchemes',
  props<{ ids: string[] }>()
);

export const clearFormulaPayableSchemes = createAction(
  '[FormulaPayableScheme/API] Clear FormulaPayableSchemes'
);

// CUSTOM
export const createFormulaPayableSchemes = createAction(
  '[FormulaPayableScheme/API] create FormulaPayableSchemes',
  props<{ input: FormulaPayableSchemeInput }>()
);


export const editFormulaPayableSchemes = createAction(
  '[FormulaPayableScheme/API] edit FormulaPayableSchemes',
  props<{ input: FormulaPayableSchemeInput }>()
);


export const removeFormulaPayableSchemes = createAction(
  '[FormulaPayableScheme/API] remove FormulaPayableSchemes',
  props<{ itemUniqueId: string; id: string }>()
);



export const getFormulaPayableSchemes = createAction(
  '[FormulaPayableScheme/API] get FormulaPayableSchemes',
  props<{ formularUniqueId: string }>()
);

// Modified
export const citizenGetInstitutionServiceFormulaPayableItems = createAction(
  '[FormulaPayableScheme/API] citizen get institution FormulaPayableSchemes',
  props<{ formularUniqueId: string }>()
);
